module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_L1-9bbde87da4d8956af9e93ac7a803db2d.webp";